import hash from 'object-hash';

export const Endpoint = (payload: Payload) => `/api/ui/audit/sbom-ai-summary?id=${payload.id}`;
export const QueryKey = (payload: Payload) =>
    ['ui', 'audit', 'sbom-ai-summary', hash(payload, { algorithm: 'md5', unorderedArrays: true })] as const;
export type Payload = {
    id: string;
};

export type Response = string;
